const state = {
  scope: null,
  refund: null,
}

export const getters = {
  refund: state => state.refund,
}

export const mutations = {
  setScope(state, scope) {
    state.scope = scope
  },

  setRefund(state, refund) {
    state.refund = refund
  },

  clearRefund(state) {
    state.refund = null
  },
}

export const actions = accountingService => ({
  async fetchRefund({ commit, state }, id) {
    if (!state.scope) {
      throw new Error('Scope not set')
    }

    commit('clearRefund')
    const refund = await accountingService.fetchRefund(state.scope, id)
    commit('setRefund', refund)
  },
})

export default accountingService => ({
  namespaced: true,
  state,
  getters,
  mutations,
  actions: actions(accountingService)
})
